import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
  DialogTitle,
  Tooltip,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import axios from "axios";
import AddFacility from "./AddFacility";
import ViewFacility from "./ViewFacility";
import DateRangePickerComponent from "../Roles and Permissions/Filters/Date";
import { api, get, put } from "../../../utils/api";
import FilterSidebar from "../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "../Roles and Permissions/Filters/ApplyButton";
import CountryFilter from "../Roles and Permissions/Filters/UserFilters/CountryFilter";
import FacilityFilter from "../Roles and Permissions/Filters/FacilityFilter";
import ResetButton from "../Roles and Permissions/Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../Components/Masters/Pagination";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import { useUser } from "../../../context/AuthContext";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { CheckCircle, Cancel } from "@mui/icons-material";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import TrialUserSidebar from "../../../Layout/TrailUserSidebar";

const Facility = () => {
  const { user } = useUser();
  let hasAccess = user?.companyAdmin;

  const [facilities, setFacilities] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addFacility, setAddFacility] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
    Facility: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [viewFacility, setViewFacility] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedFacilities, setSelectedFacilities] = useState([]); // Store selected facility name
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({
    Date: false,
    Facility: false,
    Country: false,
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const filters = ["Date", "Facility", "Country"];

  useEffect(() => {
    fetchFacilities(currentPage);
  }, [currentPage]);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [facilities]);

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/master/getAllFacility`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
      case "Facility":
        return (
          <FacilityFilter
            url={`${api}/master/getAllFacility`}
            selectedFacilities={selectedFacilities}
            setErrors={setErrors}
            setSelectedFacilities={setSelectedFacilities}
            errors={errors.Facility}
          />
        ); //
      case "Country":
        return (
          <CountryFilter
            url={`${api}/master/getAllFacility`}
            selectedCountries={selectedCountries}
            setErrors={setErrors}
            setSelectedCountries={setSelectedCountries}
            errors={errors.Country}
          />
        );
      default:
        return (
          <DateRangePickerComponent
            url={`${api}/master/getAllFacility`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
    }
  };
  const handleMenuClick = (event, facility) => {
    setAnchorEl(event.currentTarget);
    setSelectedFacility(facility);
    setdataView(facility);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedFacility(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddFacility(true);
    setViewFacility(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewFacility(true);
    setAddFacility(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = () => {
    axios
      .put(
        `${api}/master/deleteFacility`,
        { deactivated: true },
        {
          params: {
            Id: dataView._id,
          },
        }
      )
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });

        // Remove the deleted facility from the current list
        const updatedFacilities = facilities.filter(
          (item) => item._id !== res.data.data._id
        );
        setFacilities(updatedFacilities);

        // If we have less than `rowsPerPage`, fetch more data to fill it up
        if (updatedFacilities.length < rowsPerPage) {
          try {
            // Fetch the current page data again
            await fetchFacilities(currentPage);
          } catch (error) {
            console.error("Error fetching facilities:", error);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching facility data
  const fetchFacilities = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    console.log(filters);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const response = await get(`${api}/master/getAllFacility?${queryParams}`);

      setFacilities(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    country: selectedCountries.join("|"), // Use | as separator
    facilityName: selectedFacilities.join(","),
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    fetchFacilities(filtersToApply);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  // Applying reset filters
  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedCountries([]);
    setSelectedFacilities([]);
    setIsFiltersApplied(false);
    setAppliedFilters({ Facility: false, Date: false, Country: false });
    setErrors({});
    fetchFacilities({
      country: [],
      facilityName: [],
      startDate: "",
      endDate: "",
    });
    setDrawerFilterOpen(false);
  };

  // handle the applied filters for styling
  const handleAppliedFilters = () => {
    const isDateApplied = startDate || endDate ? true : false;
    const isCountryApplied = selectedCountries.length > 0;
    const isFacilityApplied = selectedFacilities.length > 0;
    // const isFunctionalityOfRoleApplied = functionalityOfRoleFilter.length > 0;

    setIsFiltersApplied(isDateApplied || isCountryApplied || isFacilityApplied);

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
      Facility: isFacilityApplied,
      // FunctionalityOfRole: isFunctionalityOfRoleApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const filterResetWithoutApply = () => {
    // Reset the selected filter only if changes were made
    if (selectedFilter === "Date") {
      setStartDate(null);
      setEndDate(null);
    } else if (selectedFilter === "Facility") {
      setSelectedFacilities([]);
    } else if (selectedFilter === "Country") {
      setSelectedCountries([]);
    }
    setDrawerFilterOpen(false); // Close the drawer without resetting everything
  };

  const handleFilterDrawer = () => {
    filterResetWithoutApply();
  };

  // const handleStatusToggle = (id, isActive) => {
  //   const newStatus = isActive ? "Active" : "Deactive";

  //   // You can now send this updated status to the backend
  //   console.log(`Status of ${id} changed to ${newStatus}`);

  //   // Example API call or state update logic here...
  // };

  const handleStatusToggle = async (id, newStatus) => {
    try {
      const response = await put(
        `${api}/master/updateFacility?Id=${id}`,
        { deactivated: newStatus }
        // {
        //   params: { Id: id },
        //   headers: { Authorization: `Bearer ${user?.token}` }, // Add if needed
        // }
      );

      // Update local state to reflect the change
      // const updatedFacilities = facilities.map((facility) =>
      //   facility._id === id ? { ...facility, deactivated: newStatus } : facility
      // );
      // setFacilities(updatedFacilities);
      fetchFacilities();
      setsnackOpen({
        open: true,
        message: "Status updated successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating status:", error);
      setsnackOpen({
        open: true,
        message: error.response?.data?.message || "Failed to update status",
        severity: "error",
      });
    }
  };

  return (
    <MainDashboardLayout sidebar={user?.isTrialUser ? <TrialUserSidebar /> : <MainSidebar />}>
      <Unauthorized requiredModule="Setup | Facility Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>

          <AddFacility
            addFacility={addFacility}
            setAddFacility={setAddFacility}
            selectedFacility={dataView}
            fetchFacilities={fetchFacilities}
            setsnackOpen={setsnackOpen}
          />
          <ViewFacility
            viewFacility={viewFacility}
            setViewFacility={setViewFacility}
            selectedFacility={dataView}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <Dialog open={deleteDialog}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAggree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* <Toolbar> */}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    onClick={() => handleFilterDrawer()}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                      // overflow:"scroll",
                      height: "100vh",
                      paddingBottom: "20%",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}
          <Box
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width: "100%",
              // marginRight: "1.5%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  paddingLeft: "0",
                  // marginLeft: "-2%",
                }}
              >
                {"Facility Master"}
              </Typography>
            </Box>
            <Box item xs={8} sx={{ textAlign: "right", my: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => setDrawerFilterOpen(true)}
                // endIcon={<FilterListIcon />}
                sx={{
                  // margin: "0px 0px 5px 0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {isFiltersApplied && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      // marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {user?.companyAdmin && (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddFacility(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              )}
            </Box>
          </Box>
          {/* </Toolbar> */}

          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ flex: 1, overflow: "hidden", mt: 1 }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                    // padding: "0px",
                  }}
                >
                  List of Facilities
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  // gridTemplateColumns: "12% 19% 19% 15% 15% 10% 10%",
                  gridTemplateColumns: hasAccess
                    ? "12% 19% 19% 15% 15% 10% 10%"
                    : "12% 20% 20% 15% 21% 10%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 16px",
                    marginBottom: "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Date
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    marginBottom: "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Name of Facility
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("facilityName", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "facilityName" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("facilityName", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "facilityName" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    marginBottom: "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Incharge
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("incharge", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "incharge" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("incharge", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "incharge" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                          color: "black",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    marginBottom: "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Outsource Facility
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("outsourceFacility", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "outsourceFacility" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("outsourceFacility", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "outsourceFacility" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    marginBottom: "-10px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Country
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                              sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("country", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "country" &&
                              sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                {hasAccess && (
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      padding: "8px 12px",
                      marginBottom: "-10px",
                      borderRight: "1px solid #ddd",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    Status
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "2px",
                        marginLeft: "10px",
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => handleSort("country", "asc")}
                      >
                        <ExpandLess
                          sx={{
                            color:
                              sortConfig.key === "country" &&
                                sortConfig.direction === "asc"
                                ? "blue"
                                : "black",
                            margin: "-10px",
                            fontSize: "20px",
                          }}
                        />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleSort("country", "desc")}
                      >
                        <ExpandMore
                          sx={{
                            color:
                              sortConfig.key === "country" &&
                                sortConfig.direction === "desc"
                                ? "blue"
                                : "black",
                            margin: "-10px",
                            fontSize: "20px",
                          }}
                        />
                      </IconButton>
                    </Box>
                  </Typography>
                )}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>

              {facilities?.length === 0 ? (
                <Box>
                  <NoDataFound />
                </Box>
              ) : (
                facilities.map((facility) => (
                  <Box
                    key={facility._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: hasAccess
                        ? "12% 19% 19% 15% 15% 10% 10%"
                        : "12% 20% 20% 15% 21% 10%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "8px 16px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {/* {new Date(facility.createdAt).toLocaleDateString()} */}
                      {new Date(facility.createdAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {facility.facilityName}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {facility.incharge}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {facility.outsourceFacility}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {facility.country}
                    </Typography>
                    {hasAccess && (
                      <Typography
                        sx={{
                          padding: "0px 0px",
                          textAlign: "center",
                          borderRight: "1px solid #ddd",
                          fontSize: "14px",
                          color: "black",
                          // marginBottom:"-1rem"
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              // checked={facility.status}
                              // onChange={(e) =>
                              //   handleStatusToggle(facility._id, e.target.checked)
                              // }
                              // color="primary"
                              checked={!facility.deactivated}
                              onChange={(e) =>
                                handleStatusToggle(
                                  facility._id,
                                  !e.target.checked
                                )
                              }
                              color="primary"
                              sx={{ marginLeft: "20%" }}
                            />
                          }
                          labelPlacement="end"
                        />
                      </Typography>
                    )}
                    <Box
                      sx={{
                        padding: "1px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton onClick={(e) => handleMenuClick(e, facility)}>
                        <MoreHorizIcon
                          sx={{ fontWeight: "bold", color: "black" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>

          {/* </TableContainer> */}

          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}

          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
              <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
              View Logs
            </MenuItem>
            <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
              <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
            </MenuItem>

            <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
              <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
              Delete
            </MenuItem>
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Facility;
